import { render, staticRenderFns } from "./AnnounceListIndex.vue?vue&type=template&id=25e6b5c6&scoped=true&"
import script from "./AnnounceListIndex.vue?vue&type=script&lang=js&"
export * from "./AnnounceListIndex.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceListIndex.vue?vue&type=style&index=0&id=25e6b5c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6b5c6",
  null
  
)

export default component.exports